// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {SimTrainingRoomService} from "@services";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ITrainingRoomWhitelist, RoomCapability, TrainingRoom, TrainingRoomGroup} from "@models";
import {Translations} from "@translations";
import {FormArray, FormBuilder, FormControl} from "@angular/forms";

export interface TRAINING_ROOM_RESTRICTION_DIALOG_INPUT extends MatDialogDataBaseInput {
	mapping: ITrainingRoomWhitelist & {name: string};
}

export interface TRAINING_ROOM_RESTRICTION_DIALOG_OUTPUT extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-training-room-restriction-dialog",
	templateUrl: "./training-room-restriction-dialog.component.html",
	styleUrls: ["./training-room-restriction-dialog.component.scss"],
	standalone: false,
})
export class TrainingRoomRestrictionDialogComponent
	extends BasicMaterialDialog<
		TrainingRoomRestrictionDialogComponent,
		TRAINING_ROOM_RESTRICTION_DIALOG_INPUT,
		TRAINING_ROOM_RESTRICTION_DIALOG_OUTPUT
	>
	implements OnInit
{
	protected readonly RoomCapability = RoomCapability;

	T = Translations;
	roomFc: FormArray<FormControl<TrainingRoom>> = new FormArray<FormControl<TrainingRoom>>([]);
	roomGroupFc: FormArray<FormControl<TrainingRoomGroup>> = new FormArray<FormControl<TrainingRoomGroup>>([]);

	constructor(
		_injector: Injector,
		private formBuilder: FormBuilder,
		private _simTrainingRoomService: SimTrainingRoomService,
	) {
		super(_injector);

		this.initialize();
	}

	private async initialize() {
		const ret = await Promise.all([
			this._simTrainingRoomService.getTrainingRooms(),
			this._simTrainingRoomService.getTrainingRoomGroups(),
		]);
		const trainingRooms = ret[0];
		const trainingRoomGroups = ret[1];

		this.roomFc = this.formBuilder.array(
			this.data.mapping.trainingRoomIds.map((id) => this.formBuilder.control(trainingRooms.find((room) => room.id === id))),
		);
		this.roomGroupFc = this.formBuilder.array(
			this.data.mapping.trainingRoomGroupIds.map((id) =>
				this.formBuilder.control(trainingRoomGroups.find((roomGroup) => roomGroup.id === id)),
			),
		);
	}

	public saveRecorderMapping() {
		this.data.mapping.trainingRoomIds = this.roomFc.controls.map((fc) => fc.value.id);
		this.data.mapping.trainingRoomGroupIds = this.roomGroupFc.controls.map((fc) => fc.value.id);

		this.close({
			action: "ok",
		});
	}
}
